import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 17CFE8D4-18D7-4414-B8EE-244D5A8FF791
 * name currency-sign
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/currency-sign.svg
 * tags
 * - Currency 
 * - Banking 
 */
export const CurrencySignIcon = createSvgIcon(<><path d="M4.41 3L3 4.41L5.69 7.1C4.63 8.46 4 10.15 4 12C4 13.85 4.63 15.55 5.69 16.9L3 19.59L4.41 21L7.1 18.31C8.46 19.37 10.15 20 12 20C13.85 20 15.55 19.37 16.9 18.31L19.59 21L21 19.59L18.31 16.9C19.37 15.54 20 13.85 20 12C20 10.15 19.37 8.45 18.31 7.1L21 4.41L19.59 3L16.9 5.69C15.54 4.63 13.85 4 12 4C10.15 4 8.45 4.63 7.1 5.69L4.41 3M12 6C15.31 6 18 8.69 18 12C18 15.31 15.31 18 12 18C8.69 18 6 15.31 6 12C6 8.69 8.69 6 12 6Z" /></>, 'CurrencySignIcon');
export default CurrencySignIcon